export default __webpack_public_path__ + "static/LargestUSCoBadge-96501e4bfb0ffaecbad2e5a0559f34c4.webp";